import { paginatedQuery } from 'lib-shared-api-utils';
import { api } from 'utils/apis/api';
import { transformFlowCreateOrUpdate } from './utils/transformArg';
import { transformFlowResponse, transformFlowScheduleCountryResponse, transformFlowSchedulePreviewResponse, transformFlowScheduleResponse, transformFlowsResponse, } from './utils/transformResponse';
export const flowsApi = api
    .enhanceEndpoints({
    addTagTypes: ['Schedule', 'ScheduleConflicts', 'ScheduleFlows'],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        createFlow: builder.mutation({
            query: (flow) => ({
                version: 1,
                path: 'flows',
                method: 'POST',
                body: transformFlowCreateOrUpdate(flow),
            }),
            invalidatesTags: ['Schedule', 'ScheduleConflicts', 'ScheduleFlows'],
        }),
        readFlow: builder.query({
            query: ({ id }) => ({
                version: 1,
                path: `flows/${id}`,
            }),
            transformResponse: transformFlowResponse,
        }),
        updateFlow: builder.mutation({
            query: ({ id, flow }) => ({
                version: 1,
                path: `flows/${id}`,
                method: 'PUT',
                body: transformFlowCreateOrUpdate(flow),
            }),
            transformResponse: transformFlowResponse,
            invalidatesTags: ['Schedule', 'ScheduleConflicts', 'ScheduleFlows'],
        }),
        deleteFlow: builder.mutation({
            query: ({ id }) => ({
                version: 1,
                path: `flows/${id}`,
                method: 'DELETE',
            }),
            transformResponse: transformFlowResponse,
            invalidatesTags: ['Schedule', 'ScheduleFlows'],
        }),
        readFlows: builder.query({
            query: (arg) => paginatedQuery(arg, ({ channel, locations }) => ({
                version: 2,
                path: 'flows',
                params: Object.assign({ channel }, ((locations === null || locations === void 0 ? void 0 : locations.length) ? { locations: locations.join(',') } : {})),
            })),
            transformResponse: transformFlowsResponse,
        }),
        createFlowSchedule: builder.mutation({
            query: (schedule) => ({
                version: 2,
                path: 'flows/schedules',
                method: 'POST',
                body: schedule,
            }),
            transformResponse: transformFlowScheduleResponse,
            invalidatesTags: ['ScheduleConflicts'],
        }),
        readFlowSchedule: builder.query({
            query: ({ id }) => ({
                version: 2,
                path: `flows/schedules/${id}`,
            }),
            transformResponse: transformFlowScheduleResponse,
            providesTags: ['Schedule'],
        }),
        updateFlowSchedule: builder.mutation({
            query: ({ id, schedule }) => ({
                version: 2,
                path: `flows/schedules/${id}`,
                method: 'PUT',
                body: schedule,
            }),
            transformResponse: transformFlowScheduleResponse,
            invalidatesTags: (_response, _error, { id }) => [
                'ScheduleConflicts',
                { type: 'Schedule', id },
            ],
        }),
        deleteFlowSchedule: builder.mutation({
            query: ({ id }) => ({
                version: 2,
                path: `flows/schedules/${id}`,
                method: 'DELETE',
            }),
            transformResponse: transformFlowScheduleResponse,
            invalidatesTags: (_response, _error, { id }) => [
                'ScheduleConflicts',
                { type: 'Schedule', id },
            ],
        }),
        readFlowsSchedules: builder.query({
            query: (arg) => paginatedQuery(arg, () => ({
                version: 2,
                path: 'flows/schedules',
            })),
        }),
        readFlowsSchedulesConflicts: builder.query({
            query: () => ({
                version: 2,
                path: 'flows/schedules/conflicts',
            }),
            providesTags: [{ type: 'ScheduleConflicts', id: 'LIST' }],
        }),
        readFlowsSchedulesFlows: builder.query({
            query: (arg) => paginatedQuery(arg, ({ id }) => ({
                version: 2,
                path: `flows/schedules/${id}/flows`,
            })),
            providesTags: ['ScheduleFlows'],
        }),
        readFlowsSchedulesBatch: builder.query({
            query: ({ ids }) => ({
                version: 2,
                path: `flows/schedules/batch`,
                params: { ids: ids.join(',') },
            }),
        }),
        readFlowsSchedulesCountry: builder.query({
            query: ({ country_code }) => ({
                version: 2,
                path: `flows/schedules/countries/${country_code}`,
            }),
            transformResponse: transformFlowScheduleCountryResponse,
        }),
        readFlowsSchedulesCountries: builder.query({
            query: () => ({
                version: 2,
                path: 'flows/schedules/countries',
            }),
        }),
        readFlowsSchedulesHolidays: builder.query({
            query: (arg) => paginatedQuery(arg, ({ country_code, timezone }) => ({
                version: 2,
                path: `flows/schedules/holidays/${country_code}`,
                params: { timezone },
            })),
        }),
        readFlowsSchedulesPreview: builder.mutation({
            query: ({ id, payload }) => ({
                version: 2,
                path: `flows/schedules/${id}/preview`,
                method: 'PUT',
                body: payload,
            }),
            transformResponse: transformFlowSchedulePreviewResponse,
        }),
        readFlowsAnnouncementUsage: builder.query({
            query: ({ id }) => ({
                version: 2,
                path: `flows/announcements/${id}/flows`,
            }),
        }),
    }),
});
